import { MultiSelectVehicleAssociationType } from '@cobliteam/common-types/src/vehicle';
import type { TFunction } from '@cobliteam/i18n';
import Icon from '@cobliteam/ui/icons';
import FilterIcon from '@cobliteam/ui-business/icons/filters/filter_alt_cb.svg?react';
import React, { Suspense } from 'react';
import MultiSelectIdentificationTokenType from '../../../MultiSelects/MultiSelectIdentificationTokenType';
import MultiSelectReminderTitle from '../../../MultiSelects/MultiSelectReminderTitle';
import type { IFiltersDef } from '../../types';
import Skeleton from './skeleton';

const SelectTimeServiceWindow = React.lazy(() => import('@cobliteam/ui-business/components/Selects/SelectTimeServiceWindow'));
const SelectMaxStopTime = React.lazy(() => import('@cobliteam/ui-business/components/Selects/SelectMaxStopTime'));
const SelectTimeWindow = React.lazy(() => import('@cobliteam/ui-business/components/Selects/SelectTimeWindow/SelectTimeWindow'));

const MultiSelectVehicles = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectVehicles'));
const MultiSelectDrivers = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDrivers'));
const MultiSelectDeviceStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDeviceStatus'));
const MultiSelectActivityStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectActivityStatus'));
const MultiSelectGeofences = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectGeofences'));
const MultiSelectUsers = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectUsers'));
const MultiSelectWeekDay = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectWeekDay'));
const MultiSelectDeviceType = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDeviceType'));
const MultiSelectVehicleGroups = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectVehicleGroups'));
const MultiSelectVehicleTags = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectVehicleTags'));
const MultiSelectRuleConditions = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectRuleConditions'));
const MultiSelectRuleStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectRuleStatus'));
const MultiSelectFaceIdIdentificationMethods = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectFaceIdIdentificationMethods'));
const MultiSelectMediaSeverity = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaSeverity'));
const MultiSelectMediaEventTrigger = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaEventTrigger'));
const MultiSelectMediaEventStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaEventStatus'));
const MultiSelectMediaRequestType = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaRequestType'));
const MultiSelectMediaRequest = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaRequest'));
const MultiSelectMediaRequestStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaRequestStatus'));
const MultiSelectMediaObstructed = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaObstructed'));
const MultiSelectVehicleSize = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectVehicleSize'));
const MultiSelectVehicleModel = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectVehicleModel'));
const MultiSelectHiredProduct = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectHiredProduct'));
const MultiSelectTriggerName = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectTriggerName'));
const MultiSelectMaintenanceCategory = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMaintenanceCategory'));
const MultiSelectMediaSafetyOccurrences = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaSafetyOccurrences'));
const MultiSelectDeviceVehicleEvents = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDeviceVehicleEvents'));
const MultiSelectDevices = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDevices'));
const MultiSelectMediaSuggestedOccurrences = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectMediaSuggestedOccurrences'));
const MultiSelectUserRoles = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectUserRoles'));
const MultiSelectInvitationStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectInvitationStatus'));
const MultiSelectSafetyReviewStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectSafetyReviewStatus'));
const MultiSelectSafetyDismissReason = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectSafetyDismissReason'));
const MultiSelectExpenseCategory = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectExpenseCategory'));
const MultiSelectExpenseType = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectExpenseType'));
const MultiSelectCnhExpiration = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectCnhExpiration'));
const MultiSelectAssociationSource = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectAssociationSource'));
const MultiSelectChecklistStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectChecklistStatus'));
const MultiSelectImmobilizerStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectImmobilizerStatus'));
const MultiSelectCreateBy = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectCreateBy'));
const MultiSelectVehicleType = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectVehicleType'));
const MultiSelectGeofenceType = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectGeofenceType'));
const MultiSelectContracts = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectContracts'));
const MultiSelectDeviceHealthStatus = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDeviceHealthStatus'));
const MultiSelectDeviceAssociation = React.lazy(() => import('@cobliteam/ui-business/components/MultiSelects/MultiSelectDeviceAssociation'));

const FiltersDef: IFiltersDef[] = [
  {
    key: 'MultiSelectDrivers',
    name: 'Motoristas',
    icon: <Icon name='cb-filters-driver-cb' size='sm' />,
    paramKey: 'driverIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.id),
    parseToValue: (param) => param.split(',').map((id: string) => ({ id, name: '' })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDrivers
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDrivers', value })}
          selectedDrivers={filters.find((f: any) => f.key === 'MultiSelectDrivers')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectDeviceStatus',
    name: 'Status do Dispositivo',
    icon: <Icon name='filter' size='sm' />,
    paramKey: 'deviceStatusIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item),
    parseToValue: (param) => param.split(','),
    component: ({ onChangeFilter, filters, options }) => {
      const associationStatus = options?.associationStatus ? options?.associationStatus : MultiSelectVehicleAssociationType.NOT_ASSOCIATED_TO_VEHICLE;
      return (
        <Suspense fallback={<Skeleton />}>
          <MultiSelectDeviceStatus
            size='sm'
            associationStatus={associationStatus}
            onChange={(value) =>
              onChangeFilter({
                key: 'MultiSelectDeviceStatus',
                value,
              })
            }
            selectedStatus={filters.find((f: any) => f.key === 'MultiSelectDeviceStatus')?.value ?? new Set()}
          />
        </Suspense>
      );
    },
  },
  {
    key: 'MultiSelectUsers',
    name: 'Usuários',
    icon: <Icon name='user-round-plus' size='sm' />,
    paramKey: 'usersIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.id),
    parseToValue: (param) => param.split(',').map((id: string) => ({ id, name: '' })),
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectUsers
          size='sm'
          title={options?.name}
          icon={options?.icon}
          onChange={(value) => onChangeFilter({ key: 'MultiSelectUsers', value })}
          selectedUsersIds={filters.find((f: any) => f.key === 'MultiSelectUsers')?.value.map((v: any) => v.id) ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectUsersByEmail',
    name: 'Usuários',
    icon: <Icon name='user-round' size='sm' />,
    paramKey: 'usersIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => `${item.email}/${item.id}`),
    parseToValue: (param) => {
      return param.split(',').map((p) => {
        const [email, id] = p.split('/');
        return { email, id };
      });
    },
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectUsers
          size='sm'
          title={options?.name}
          icon={<Icon name='user-round' size='sm' />}
          onChange={(value) => onChangeFilter({ key: 'MultiSelectUsersByEmail', value })}
          selectedUsersIds={filters.find((f: any) => f.key === 'MultiSelectUsersByEmail')?.value.map((v: any) => v.id) ?? []}
          listByEmail
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectGeofences',
    name: 'Locais',
    icon: <Icon name='map-pin' size='sm' />,
    paramKey: 'geofenceIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.id),
    parseToValue: (param) => param.split(',').map((id: string) => ({ id, name: '' })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectGeofences
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectGeofences', value })}
          selectedGeofencesIds={filters.find((f: any) => f.key === 'MultiSelectGeofences')?.value.map((v: any) => v.id) ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectGeofenceType',
    name: 'Tipo de local',
    icon: <Icon name='map-pin' size='sm' />,
    paramKey: 'geofenceType',
    parseToParam: (value: []) => value.map((item) => item),
    parseToValue: (param) => param.split(',').map((value: string) => value),
    value: [],
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectGeofenceType
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectGeofenceType', value })}
          selectedTypes={filters.find((f: any) => f.key === 'MultiSelectGeofenceType')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicleGroups',
    name: 'Grupos',
    icon: <Icon name='cb-filters-vehicle-group-cb' size='sm' />,
    paramKey: 'vehicleGroupsIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.id),
    parseToValue: (param) => param.split(',').map((id: string) => ({ id, name: '' })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectVehicleGroups
          size='sm'
          onChange={(value) =>
            onChangeFilter({
              key: 'MultiSelectVehicleGroups',
              value,
            })
          }
          selectedVehicleGroups={filters.find((f: any) => f.key === 'MultiSelectVehicleGroups')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicles',
    name: 'Veículos',
    icon: <Icon name='car-front' size='sm' />,
    paramKey: 'vehicleIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.id),
    parseToValue: (param) => param.split(',').map((id: string) => ({ id, name: '' })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectVehicles
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectVehicles', value })}
          selectedVehicles={filters.find((f: any) => f.key === 'MultiSelectVehicles')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicleTags',
    name: 'Tags de Veículos',
    icon: <Icon name='tag' size='sm' />,
    paramKey: 'vehicleTags',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.name),
    parseToValue: (param) => param.split(',').map((item: string) => ({ name: item })),
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectVehicleTags
          size='sm'
          title={options?.title}
          onChange={(value) => onChangeFilter({ key: 'MultiSelectVehicleTags', value })}
          selectedVehicleTags={filters.find((f: any) => f.key === 'MultiSelectVehicleTags')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicleType',
    name: 'Tipo de veículo',
    icon: <Icon name='car' size='sm' />,
    paramKey: 'vehicleType',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.value),
    parseToValue: (param) => param.split(',').map((value: string) => ({ value })),
    component: ({ onChangeFilter, filters, options }) => {
      return (
        <Suspense fallback={<Skeleton />}>
          <MultiSelectVehicleType
            size='sm'
            title={options?.title}
            onChange={(value: any) => onChangeFilter({ key: 'MultiSelectVehicleType', value })}
            selectedOptions={filters.find((f: any) => f.key === 'MultiSelectVehicleType')?.value ?? []}
          />
        </Suspense>
      );
    },
  },
  {
    key: 'MultiSelectFaceIdIdentificationMethods',
    name: 'Identificado por',
    icon: <Icon name='scan-face' size='sm' />,
    paramKey: 'identificationMethods',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectFaceIdIdentificationMethods
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectFaceIdIdentificationMethods',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectFaceIdIdentificationMethods')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaSeverity',
    name: 'Gravidade',
    icon: <Icon name='zap' size='sm' />,
    paramKey: 'severity',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaSeverity
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaSeverity',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaSeverity')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaEventTrigger',
    name: 'Eventos',
    icon: <Icon name='zap' size='sm' />,
    paramKey: 'eventTrigger',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaEventTrigger
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaEventTrigger',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaEventTrigger')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaEventStatus',
    name: 'Status',
    icon: <Icon name='zap' size='sm' />,
    paramKey: 'watchStatus',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaEventStatus
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaEventStatus',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaEventStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaRequestType',
    name: 'Categoria do video',
    icon: <Icon name='zap' size='sm' />,
    paramKey: 'requestType',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaRequestType
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaRequestType',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaRequestType')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaRequestStatus',
    name: 'Status',
    icon: <Icon name='zap' size='sm' />,
    paramKey: 'requestStatus',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaRequestStatus
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaRequestStatus',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaRequestStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaSafetyOccurrences',
    name: 'Ocorrências',
    icon: <Icon name='octagon-alert' size='sm' />,
    paramKey: 'mediaSafetyOccurrences',
    value: [],
    parseToParam: (value: { id: string }[]) => value.map((item) => item.id).join(','),
    parseToValue: (param: string) => param.split(',').map((id) => ({ id })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaSafetyOccurrences
          size='sm'
          onChange={(value) =>
            onChangeFilter({
              key: 'MultiSelectMediaSafetyOccurrences',
              value,
            })
          }
          selectedSafetyOccurrences={filters.find((f: any) => f.key === 'MultiSelectMediaSafetyOccurrences')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaSuggestedOccurrences',
    name: 'Sugestões da IA',
    icon: <Icon name='sparkles' size='sm' />,
    paramKey: 'suggestedOccurrence',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaSuggestedOccurrences
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaSuggestedOccurrences',
              value,
            })
          }
          selectedSuggestedOccurrences={filters.find((f: any) => f.key === 'MultiSelectMediaSuggestedOccurrences')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaRequest',
    name: 'Solicitação',
    icon: <Icon name='hand' size='sm' />,
    paramKey: 'request',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaRequest
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaRequest',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaRequest')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMediaObstructed',
    name: 'Câmera obstruída',
    icon: <Icon name='video-off' size='sm' />,
    paramKey: 'isObstructed',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMediaObstructed
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMediaObstructed',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMediaObstructed')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectDeviceType',
    name: 'Tipo de Dispositivo',
    icon: <Icon name='router' size='sm' />,
    paramKey: 'deviceTypes',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item),
    parseToValue: (param) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDeviceType
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDeviceType', value })}
          selectedTypes={filters.find((f: any) => f.key === 'MultiSelectDeviceType')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectWeekDay',
    name: 'Dias da semana',
    icon: <Icon name='cb-leading' size='sm' />,
    paramKey: 'weekDays',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectWeekDay
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectWeekDay', value })}
          selectedDays={filters.find((f: any) => f.key === 'MultiSelectWeekDay')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectAssociationSource',
    name: 'Associação',
    icon: <Icon name='cb-leading' size='sm' />,
    paramKey: 'associationSources',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectAssociationSource
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectAssociationSource', value })}
          selectedTypes={filters.find((f: any) => f.key === 'MultiSelectAssociationSource')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectRuleConditions',
    name: 'Condições',
    icon: <Icon name='cb-leading' size='sm' />,
    paramKey: 'ruleConditionIds',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param) => param.split(','),
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectRuleConditions
          size='sm'
          onChange={(value) =>
            onChangeFilter({
              key: 'MultiSelectRuleConditions',
              value,
            })
          }
          selectedConditions={filters.find((f: any) => f.key === 'MultiSelectRuleConditions')?.value ?? []}
          selectedRule={options?.selectedRule}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectRuleStatus',
    name: 'Status da regra',
    icon: <Icon name='cb-leading' size='sm' />,
    paramKey: 'ruleStatus',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectRuleStatus
          size='sm'
          onChange={(value: any) => onChangeFilter({ key: 'MultiSelectRuleStatus', value })}
          selectedRuleStatus={filters.find((f: any) => f.key === 'MultiSelectRuleStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectChecklistStatus',
    name: 'Status do checklist',
    icon: <Icon name='filter' size='sm' />,
    paramKey: 'checklistStatus',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectChecklistStatus
          size='sm'
          onChange={(value: any) => onChangeFilter({ key: 'MultiSelectChecklistStatus', value })}
          selectedStatus={filters.find((f: any) => f.key === 'MultiSelectChecklistStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicleSize',
    name: 'Porte do veículo',
    icon: <FilterIcon className='size-4' />,
    paramKey: 'vehicleSize',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectVehicleSize
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectVehicleSize',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectVehicleSize')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicleModel',
    name: 'Modelo do veículo',
    icon: <Icon name='car' size='sm' />,
    paramKey: 'vehicleModel',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.value),
    parseToValue: (param) => param.split(',').map((value: string) => ({ value })),
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectVehicleModel
          size='sm'
          title={options?.title}
          onChange={(value) => onChangeFilter({ key: 'MultiSelectVehicleModel', value })}
          selectedVehicleModels={filters.find((f: any) => f.key === 'MultiSelectVehicleModel')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'SelectTimeServiceWindow',
    name: 'Horário',
    icon: <Icon name='hourglass' size='sm' />,
    paramKey: 'windowTimeService',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <SelectTimeServiceWindow
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'SelectTimeServiceWindow',
              value,
            })
          }
          selectedHours={filters.find((f: any) => f.key === 'SelectTimeServiceWindow')?.value ?? undefined}
        />
      </Suspense>
    ),
  },
  {
    key: 'SelectMaxStopTime',
    name: 'Tempo Máximo de Parada',
    icon: <Icon name='hourglass' size='sm' />,
    paramKey: 'maxStopTime',
    value: undefined,
    parseToParam: (value: number | undefined) => (value ? value.toString() : ''),
    parseToValue: (param: string) => {
      const value = param.split(',').map(Number)[0];
      return value >= 5999 ? 5999 : value;
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <SelectMaxStopTime
          size='sm'
          onChange={(value: any) => onChangeFilter({ key: 'SelectMaxStopTime', value })}
          selectedMinutes={filters.find((f: any) => f.key === 'SelectMaxStopTime')?.value ?? undefined}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectHiredProduct',
    name: 'Produto contratado',
    icon: <Icon name='package-check' size='sm' />,
    paramKey: 'hiredProduct',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectHiredProduct
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectHiredProduct',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectHiredProduct')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'SelectTimeWindow',
    name: 'Horário do trajeto',
    icon: <Icon name='hourglass' size='sm' />,
    paramKey: 'timeWindow',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <SelectTimeWindow
          size='sm'
          internalLabel={options?.internalLabel}
          selectedTimeWindow={filters.find((f: any) => f.key === 'SelectTimeWindow')?.value ?? undefined}
          minStartTime={filters.find((f: any) => f.key === 'SelectTimeWindow')?.value?.[0] ?? undefined}
          maxEndTime={filters.find((f: any) => f.key === 'SelectTimeWindow')?.value?.[1] ?? undefined}
          onTimeChange={(start: number, end: number) => onChangeFilter({ key: 'SelectTimeWindow', value: [start, end] })}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectMaintenanceCategory',
    name: 'Categoria',
    icon: <FilterIcon className='size-4' />,
    paramKey: 'maintenanceCategory',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectMaintenanceCategory
          size='sm'
          onChange={(value: any) =>
            onChangeFilter({
              key: 'MultiSelectMaintenanceCategory',
              value,
            })
          }
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectMaintenanceCategory')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectTriggerName',
    name: 'Regra solicitante',
    icon: <Icon name='file-text' size='sm' />,
    paramKey: 'trigger',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters, options }) => {
      const requestVideo = options?.requestVideo ? options?.requestVideo : undefined;

      return (
        <Suspense fallback={<Skeleton />}>
          <MultiSelectTriggerName
            size='condensed'
            onChange={(value: any) =>
              onChangeFilter({
                key: 'MultiSelectTriggerName',
                value,
              })
            }
            selectedOptions={filters.find((f: any) => f.key === 'MultiSelectTriggerName')?.value ?? []}
            requestVideo={requestVideo}
          />
        </Suspense>
      );
    },
  },
  {
    key: 'MultiSelectDeviceVehicleEvents',
    name: 'Eventos',
    icon: <Icon name='cb-filters-filter-alt-cb' size='sm' />,
    paramKey: 'vehicleDeviceEvents',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDeviceVehicleEvents
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDeviceVehicleEvents', value })}
          selectedEvents={filters.find((f: any) => f.key === 'MultiSelectDeviceVehicleEvents')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectVehicleDeviceEvents',
    name: 'Eventos',
    icon: <Icon name='cb-filters-filter-alt-cb' size='sm' />,
    paramKey: 'deviceVehicleEvents',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDeviceVehicleEvents
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectVehicleDeviceEvents', value })}
          selectedEvents={filters.find((f: any) => f.key === 'MultiSelectVehicleDeviceEvents')?.value ?? []}
          inVehiclesTab
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectDevices',
    name: 'Dispositivos',
    icon: <Icon name='cb-obd' size='sm' />,
    paramKey: 'deviceIds',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param) => param.split(',').map((id: string) => ({ id, name: '' })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDevices
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDevices', value })}
          selectedDevicesIds={filters.find((f: any) => f.key === 'MultiSelectDevices')?.value.map((v: any) => v.id) ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectUserRoles',
    name: 'Funções de usuário',
    icon: <Icon name='cog' size='sm' />,
    paramKey: 'userRoles',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectUserRoles
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectUserRoles', value });
          }}
          selectedRoles={filters.find((f: any) => f.key === 'MultiSelectUserRoles')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectInvitationStatus',
    name: 'Status do convite do usuário',
    icon: <Icon name='cog' size='sm' />,
    paramKey: 'invitationStatus',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectInvitationStatus
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectInvitationStatus', value });
          }}
          selectedStatus={filters.find((f: any) => f.key === 'MultiSelectInvitationStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectSafetyReviewStatus',
    name: 'Status de revisão',
    icon: <Icon name='file-video' size='sm' />,
    paramKey: 'safetyReviewStatus',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectSafetyReviewStatus
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectSafetyReviewStatus', value });
          }}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectSafetyReviewStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectSafetyDismissReason',
    name: 'Motivo de dispensa',
    icon: <Icon name='file-video' size='sm' />,
    paramKey: 'safetyDismissReason',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectSafetyDismissReason
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectSafetyDismissReason', value });
          }}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectSafetyDismissReason')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectExpenseCategory',
    name: 'Categorias de despesas',
    icon: <Icon name='wallet-cards' size='sm' />,
    paramKey: 'expenseCategory',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectExpenseCategory
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectExpenseCategory', value });
          }}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectExpenseCategory')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectExpenseType',
    name: 'Tipos de despesas',
    icon: <Icon name='receipt' size='sm' />,
    paramKey: 'expenseType',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectExpenseType
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectExpenseType', value });
          }}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectExpenseType')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectCnhExpiration',
    name: 'Data de vencimento da CNH',
    icon: <Icon name='cb-filters-filter-alt-cb' size='sm' />,
    paramKey: 'cnhExpiration',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectCnhExpiration
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectCnhExpiration', value });
          }}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectCnhExpiration')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectActivityStatus',
    name: 'Status da atividade',
    icon: <Icon name='files' size='sm' />,
    paramKey: 'activityStatus',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectActivityStatus
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectActivityStatus', value });
          }}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectActivityStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectIdentificationTokenType',
    name: 'Tipos de identificadores',
    icon: <Icon name='receipt' size='sm' />,
    paramKey: 'identifiersTokenType',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectIdentificationTokenType
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectIdentificationTokenType', value });
          }}
          selectedTypes={filters.find((f: any) => f.key === 'MultiSelectIdentificationTokenType')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectImmobilizerStatus',
    name: 'Trava de ignição',
    icon: <Icon name='receipt' size='sm' />,
    paramKey: 'immobilizerStatus',
    value: [],
    parseToParam: (value: []) => {
      return value;
    },
    parseToValue: (param: string) => {
      return param.split(',');
    },
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectImmobilizerStatus
          size='sm'
          onChange={(value) => {
            onChangeFilter({ key: 'MultiSelectImmobilizerStatus', value });
          }}
          selectedImmobilizerStatus={filters.find((f: any) => f.key === 'MultiSelectImmobilizerStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectCreateBy',
    name: 'Criado por',
    icon: <Icon name='user-round' size='sm' />,
    paramKey: 'createBy',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.name),
    parseToValue: (param) => param.split(',').map((name: string) => ({ name })),
    component: ({ onChangeFilter, filters, options }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectCreateBy
          size='sm'
          title={options?.name}
          icon={options?.icon}
          onChange={(value) => onChangeFilter({ key: 'MultiSelectCreateBy', value })}
          selectedUsersIds={filters.find((f: any) => f.key === 'MultiSelectCreateBy')?.value.map((v: any) => v.name) ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectDriversByName',
    name: 'Motoristas',
    icon: <Icon name='cb-filters-driver-cb' size='sm' />,
    paramKey: 'driverNames',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.name),
    parseToValue: (param) => param.split(',').map((name: string) => ({ id: name, name })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDrivers
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDriversByName', value })}
          selectedDrivers={filters.find((f: any) => f.key === 'MultiSelectDriversByName')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectContracts',
    name: 'Contratos',
    icon: <Icon name='file-text' size='sm' />,
    paramKey: 'contractIds',
    value: [],
    parseToParam: (value: []) => value.map((item: any) => item.companyId),
    parseToValue: (param) => param.split(',').map((companyId: string) => ({ companyId, razao_social: '', cnpj: '' })),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectContracts
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectContracts', value })}
          selectedContracts={filters.find((f: any) => f.key === 'MultiSelectContracts')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectDeviceHealthStatus',
    name: 'Status do dispositivo',
    icon: <Icon name='square-activity' size='sm' />,
    paramKey: 'deviceHealthStatus',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDeviceHealthStatus
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDeviceHealthStatus', value })}
          selectedStatus={filters.find((f: any) => f.key === 'MultiSelectDeviceHealthStatus')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectDeviceAssociation',
    name: 'Associações',
    icon: <Icon name='link' size='sm' />,
    paramKey: 'deviceAssociation',
    value: [],
    parseToParam: (value: []) => value,
    parseToValue: (param: string) => param.split(','),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectDeviceAssociation
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectDeviceAssociation', value })}
          selectedAssociation={filters.find((f: any) => f.key === 'MultiSelectDeviceAssociation')?.value ?? []}
        />
      </Suspense>
    ),
  },
  {
    key: 'MultiSelectReminderTitle',
    name: 'Manutenção',
    icon: <Icon name='file-text' size='sm' />,
    paramKey: 'reminderTitles',
    value: [],
    parseToParam: (value: []) => value.map((titleId: string) => titleId),
    parseToValue: (param) => param.split(',').map((titleId: string) => titleId),
    component: ({ onChangeFilter, filters }) => (
      <Suspense fallback={<Skeleton />}>
        <MultiSelectReminderTitle
          size='sm'
          onChange={(value) => onChangeFilter({ key: 'MultiSelectReminderTitle', value })}
          selectedOptions={filters.find((f: any) => f.key === 'MultiSelectReminderTitle')?.value ?? []}
        />
      </Suspense>
    ),
  },
];

type FiltersKeys = (typeof FiltersDef)[number]['key'];

export const getFiltersLabels = (t: TFunction) => {
  const labels: { [key in FiltersKeys]: string } = {
    MultiSelectDrivers: t('filters.drivers', { ns: 'common' }),
    MultiSelectDeviceStatus: t('filters.device_status', { ns: 'common' }),
    MultiSelectUsers: t('filters.users', { ns: 'common' }),
    MultiSelectUsersByEmail: t('filters.users', { ns: 'common' }),
    MultiSelectGeofences: t('filters.locations', { ns: 'common' }),
    MultiSelectGeofenceType: t('filters.geofence_type', { ns: 'common' }),
    MultiSelectVehicleGroups: t('filters.groups', { ns: 'common' }),
    MultiSelectVehicles: t('filters.vehicles', { ns: 'common' }),
    MultiSelectVehicleTags: t('filters.vehicle_tags', { ns: 'common' }),
    MultiSelectFaceIdIdentificationMethods: t('filters.identified_by', { ns: 'common' }),
    MultiSelectMediaSeverity: t('filters.severity', { ns: 'common' }),
    MultiSelectMediaEventTrigger: t('filters.events', { ns: 'common' }),
    MultiSelectMediaEventStatus: t('filters.status', { ns: 'common' }),
    MultiSelectMediaRequestType: t('filters.video_category', { ns: 'common' }),
    MultiSelectMediaRequestStatus: t('filters.status', { ns: 'common' }),
    MultiSelectMediaSafetyOccurrences: t('filters.occurrences', { ns: 'common' }),
    MultiSelectMediaSuggestedOccurrences: t('filters.ai_suggestions', { ns: 'common' }),
    MultiSelectMediaRequest: t('filters.request', { ns: 'common' }),
    MultiSelectMediaObstructed: t('filters.camera_obstructed', { ns: 'common' }),
    MultiSelectDeviceType: t('filters.device_type', { ns: 'common' }),
    MultiSelectWeekDay: t('filters.week_days', { ns: 'common' }),
    MultiSelectAssociationSource: t('filters.association', { ns: 'common' }),
    MultiSelectRuleConditions: t('filters.conditions', { ns: 'common' }),
    MultiSelectRuleStatus: t('filters.rule_status', { ns: 'common' }),
    MultiSelectVehicleSize: t('filters.vehicle_size', { ns: 'common' }),
    MultiSelectEvent: t('filters.events', { ns: 'common' }),
    MultiSelectVehicleModel: t('filters.vehicle_model', { ns: 'common' }),
    SelectTimeServiceWindow: t('filters.time', { ns: 'common' }),
    SelectMaxStopTime: t('filters.max_stop_time', { ns: 'common' }),
    MultiSelectHiredProduct: t('filters.hired_product', { ns: 'common' }),
    SelectTimeWindow: t('filters.route_time', { ns: 'common' }),
    MultiSelectMaintenanceCategory: t('filters.category', { ns: 'common' }),
    MultiSelectTriggerName: t('filters.requesting_rule', { ns: 'common' }),
    MultiSelectDeviceVehicleEvents: t('filters.events', { ns: 'common' }),
    MultiSelectVehicleDeviceEvents: t('filters.events', { ns: 'common' }),
    MultiSelectDevices: t('filters.devices', { ns: 'common' }),
    MultiSelectUserRoles: t('filters.user_roles', { ns: 'common' }),
    MultiSelectInvitationStatus: t('filters.user_invitation_status', { ns: 'common' }),
    MultiSelectSafetyReviewStatus: t('filters.review_status', { ns: 'common' }),
    MultiSelectSafetyDismissReason: t('filters.dismiss_reason', { ns: 'common' }),
    MultiSelectActivityStatus: t('filters.activity_status', { ns: 'common' }),
    MultiSelectExpenseCategory: t('filters.expense_categories', { ns: 'common' }),
    MultiSelectExpenseType: t('filters.expense_types', { ns: 'common' }),
    MultiSelectCnhExpiration: t('filters.cnh_expiration', { ns: 'common' }),
    MultiSelectIdentificationTokenType: t('filters.identifier_types', { ns: 'common' }),
    MultiSelectChecklistStatus: t('filters.status', { ns: 'common' }),
    MultiSelectImmobilizerStatus: t('filters.immobilizer_status', { ns: 'common' }),
    MultiSelectCreateBy: t('filters.create_by', { ns: 'common' }),
    MultiSelectVehicleType: t('filters.vehicle_type', { ns: 'common' }),
    MultiSelectDriversByName: t('filters.drivers', { ns: 'common' }),
    MultiSelectContracts: t('filters.contracts', { ns: 'common' }),
    MultiSelectReminderTitle: t('filters.reminder_title', { ns: 'common' }),
    MultiSelectDeviceHealthStatus: t('filters.device_health_status', { ns: 'common' }),
    MultiSelectDeviceAssociation: t('filters.device_association', { ns: 'common' }),
  };

  return labels;
};

export default FiltersDef;
